import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of, tap, throwError } from 'rxjs';
import { couponRedeemMock } from '../model/dataModel';
import { ApiService, ILicenseCar } from './api.service';
import { IconfirmOTP, IEcoupon } from '../model/ecouponInterface';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';
@Injectable({
  providedIn: 'root',
})
export class MockApiService extends ApiService {
  private readonly loggingService = inject(LoggingService);

  getAllLicensCar(): Observable<ILicenseCar> {
    return of(couponRedeemMock).pipe(
      tap((res) => this.loggingService.warn('GET | getAllcouponRedeemMock[MOCK] :', res)),
      map((res: any) => res.data),
      catchError((error) => {
        this.loggingService.error(error);
        return throwError(() => error);
      })
    );
  }
  postForm(form: IEcoupon) {
    this.loggingService.log('PostForm[MockApiService]', form);
    return of();
  }
  getProvince() {
    return of();
  }
  confirmOTP(otp: IconfirmOTP) {
    return of();
  }
  getDetailCampaign(id: string, brand: string) {
    return of();
  }
  getCheckCampaignFull(id: string) {
    return of();
  }
  getCheckCampaignExpire(id: string) {
    return of();
  }
}
